// removed by extract-text-webpack-plugin
module.exports = {"tooltip":"tooltip_tooltip--2YrF99f3","tooltip__icon-wrapper":"tooltip_tooltip__icon-wrapper--3SywPGXb","tooltipIconWrapper":"tooltip_tooltip__icon-wrapper--3SywPGXb","tooltip__icon":"tooltip_tooltip__icon--2HmQeJx4","tooltipIcon":"tooltip_tooltip__icon--2HmQeJx4","tooltip__content":"tooltip_tooltip__content--7DnCnTNX","tooltipContent":"tooltip_tooltip__content--7DnCnTNX"};


//////////////////
// WEBPACK FOOTER
// ./components/tooltip/src/styles/tooltip.scss
// module id = 2352
// module chunks = 0